import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { saveByteArray } from "src/util/saveByteArray";

enum LegalProcessDiligenceEnum {
  downloadReport = "/download-report/",
  updateReport = "/update-report-status/",
  getByTradeId = "/get-by-trade/"
}

export default class LegalProcessDiligenceService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/legal-process-diligence");
  }
  public updateReport = async id => await this.PUT(LegalProcessDiligenceEnum.updateReport + id, null, "json");

  public downloadReport = async (id:number, tradeId:number = null) => {
    const data = await this.GET(LegalProcessDiligenceEnum.downloadReport + id, "blob");
    saveByteArray(`relatório_diligencia_${tradeId}.xlsx`, data);
    return data;
  };
  public getByTradeId = async (idTrade: number) => {
    const data = await this.GET(LegalProcessDiligenceEnum.getByTradeId + idTrade);
    return data;
  };
}
